import React, { useState, useEffect } from "react";
import { FaAddressBook, FaSearch, FaRegWindowClose } from "react-icons/fa";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Button from "react-bootstrap/Button";
import dateToISOString from '../../components/app/dateToISOString';

const CustomHeader = ({ tableManager, selectedRowsIds, allowWrite, modal_excel, modal_sc, setStringFilter, addButton }) => {
  const { searchApi, columnsVisibilityApi, columnsApi } = tableManager;
  const { searchText, setSearchText } = searchApi;
  const [timer, setTimer] = useState(null);
  const currentDate = new Date();

  const [dates, setDates] = useState({
    startDate: new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate(), 0, 0, 0, 0),
    endDate: new Date(currentDate.getFullYear(), currentDate.getMonth(), currentDate.getDate(), 23, 59, 59, 999),
  });

  useEffect(() => {
    const dateRangeRegex = /range=createdAt\|([^|]+)\|([^|]+)/;
    const matches = searchText.match(dateRangeRegex);

    if (matches) {
      const datePartIni = matches[1].split("T")[0];
      const [yearIni, monthIni, dayIni] = datePartIni.split('-');
      const start = new Date(yearIni, monthIni - 1, dayIni);

      const datePartEnd = matches[2].split("T")[0];
      const [yearEnd, monthEnd, dayEnd] = datePartEnd.split('-');
      const end = new Date(yearEnd, monthEnd - 1, dayEnd, 23, 59, 59, 999);

      setDates({ startDate: start, endDate: end });
    }
  }, [searchText]);

  const handlerDates = () => {

    if (timer) {
      clearTimeout(timer);
      setTimer(null);
    }

    setTimer(
      setTimeout(() => {
        const dateRangeRegex = /range=createdAt\|([^|]+)\|([^|]+)/;

        const startDateISOString = dateToISOString(dates.startDate);
        const endDateISOString = dateToISOString(dates.endDate, true);

        const updatedSearchText = searchText.includes("range=createdAt")
          ? searchText.replace(dateRangeRegex, `range=createdAt|${startDateISOString}|${endDateISOString}`)
          : `${searchText}&range=createdAt|${startDateISOString}|${endDateISOString}`;

        setSearchText(updatedSearchText);
        setStringFilter(updatedSearchText);
      }, 1500)
    );
  };

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        padding: "10px 20px",
        background: "#fff",
        width: "100%",
        borderBottom: "1px solid #eee"
      }}
    >
      <ul style={{ listStyleType: 'none' }} id='ListGroup'>
        <li className='styleUl'> <Button className="btn btn-success" size="sm" onClick={() => { modal_excel(0, "Create"); }} >Export as Excel</Button> </li>
        <li className='styleUl'> {addButton} </li>
        <li className='styleUl'>
          {selectedRowsIds.length > 0 && allowWrite
            ? (<Button type="button" className="btn btn-warning" alt="Create" size="sm" onClick={() => { modal_sc(0, "Create"); }}> <FaAddressBook /> Edit MultiSelection </Button>)
            : ('')}
        </li>

        <li style={{ float: 'right', padding: '6px', width: '80px' }}>
          <Button
            className="btn btn-primary"
            id="btnSearch"
            size="sm"
            title="Search"
            onClick={() => { handlerDates(); }}
          >
            <FaSearch title="Search" />
          </Button>

          <Button
            className="btn btn-danger"
            size="sm"
            id="btnClear"
            title="Clear"
            onClick={(e) => {
              e.preventDefault();
              window.location.href = '';
            }}
          >
            <FaRegWindowClose title="Clear" />
          </Button>

        </li>
        <li style={{ float: 'right', padding: '6px', width: '320px' }}>
          <div className="customDatePickerWidth">
            <div id="start-date-picker">
              <DatePicker
                selected={dates.startDate}
                onChange={(date) => {setDates({ ...dates, startDate: date })}}
                selectsStart
                startDate={dates.startDate}
                endDate={dates.endDate}
                dateFormat="dd/MM/yyyy"
              />
            </div>

            <div id="end-date-picker">
              <DatePicker
                selected={dates.endDate}
                onChange={(date) => {setDates({ ...dates, endDate: date })}}
                selectsEnd
                startDate={dates.startDate}
                endDate={dates.endDate}
                minDate={dates.startDate}
                dateFormat="dd/MM/yyyy"
              />
            </div>
          </div>
        </li>

      </ul>
    </div>
  );
};

export default CustomHeader;